<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="warning">
      <h4 class="alert-heading">
        {{ getContentItem("creditDetailNotFound") }}
      </h4>
      <p
        class="my-4"
      >
        {{ format(getContentItem("notFoundExplanation"), tenantDetails.SupportPhoneNumber) }}
      </p>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins";

  export default {
    name: "NotFound",
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
    },
    mixins: [stringHelper],
  };
</script>
